module.exports = __webpack_public_path__ + "img/icon-logo.fc6d5cfd.png";